import React, { useState } from 'react';
import { Filter, ChevronDown } from 'lucide-react';

const SortFilterControls = ({ onSort, onFilter }) => {
  const [sortOpen, setSortOpen] = useState(false);
  const [filterOpen, setFilterOpen] = useState(false);

  const sortOptions = [
    { label: 'Date: Newest First', value: 'date_desc' },
    { label: 'Date: Oldest First', value: 'date_asc' },
    { label: 'Weight: Heaviest First', value: 'weight_desc' },
    { label: 'Weight: Lightest First', value: 'weight_asc' },
    { label: 'Load ID: Ascending', value: 'id_asc' },
    { label: 'Load ID: Descending', value: 'id_desc' },
  ];

  const filterOptions = [
    { label: 'All', value: 'all' },
    { label: 'Open', value: 'open' },
    { label: 'Assigned', value: 'assigned' },
    { label: 'In Transit', value: 'in_transit' },
    { label: 'Completed', value: 'completed' },
    { label: 'Resubmitted', value: 'resubmitted' },
  ];

  return (
    <div className="flex space-x-4 mb-4">
      <div className="relative">
        <button
          onClick={() => setSortOpen(!sortOpen)}
          className="flex items-center px-4 py-2 bg-white border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          Sort
          <ChevronDown className="ml-2 h-4 w-4" />
        </button>
        {sortOpen && (
          <div className="absolute z-10 mt-1 w-56 bg-white shadow-lg rounded-md py-1">
            {sortOptions.map((option) => (
              <button
                key={option.value}
                onClick={() => {
                  onSort(option.value);
                  setSortOpen(false);
                }}
                className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              >
                {option.label}
              </button>
            ))}
          </div>
        )}
      </div>
      <div className="relative">
        <button
          onClick={() => setFilterOpen(!filterOpen)}
          className="flex items-center px-4 py-2 bg-white border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          <Filter className="mr-2 h-4 w-4" />
          Filter
        </button>
        {filterOpen && (
          <div className="absolute z-10 mt-1 w-56 bg-white shadow-lg rounded-md py-1">
            {filterOptions.map((option) => (
              <button
                key={option.value}
                onClick={() => {
                  onFilter(option.value);
                  setFilterOpen(false);
                }}
                className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              >
                {option.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SortFilterControls;

